import React, { useEffect, useState } from 'react';
import { marked } from "marked";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const ReleaseNotes = ({ show, setShow }) => {
    const [data, setData] = useState(null);
    const [markdown, setMarkdown] = useState(null);

    const fetchNotes = async () => {
        let response = await fetch("/releasenotes.md");
        setData(await response.text());
    }

    useEffect(() => {
        fetchNotes();
    }, []);

    useEffect(() => {
        if (data != null) {
            setMarkdown(marked.parse(data))
        }
    }, [data]);

    return (
        <>
            <Modal isOpen={show}>
                <ModalHeader>
                    Release notes
                </ModalHeader>
                <ModalBody>
                    <div dangerouslySetInnerHTML={{ __html: markdown }} />
                </ModalBody>
                <ModalFooter>
                    <Button onClick={() => setShow(false)}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
}

export default ReleaseNotes;
